
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locality-directory",
      function () {
        return require("private-next-pages/locality-directory.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locality-directory"])
      });
    }
  